var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "div",
            {
              staticClass: "section operations",
              staticStyle: { height: "39px" }
            },
            [
              _c("div", { staticClass: "triggers" }, [
                _c(
                  "div",
                  [
                    _c(
                      "span",
                      {
                        staticStyle: {
                          display: "inline-block",
                          width: "90px",
                          color: "#333333"
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Months")))]
                    ),
                    _c("el-input-number", {
                      staticStyle: { "margin-right": "5px" },
                      attrs: {
                        no: "currentMonth",
                        "controls-position": "right",
                        disabled: _vm.isCopySave
                      },
                      on: { change: _vm.handleChange },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.handleNativeChange($event)
                        }
                      },
                      model: {
                        value: _vm.currentMonth,
                        callback: function($$v) {
                          _vm.currentMonth = $$v
                        },
                        expression: "currentMonth"
                      }
                    }),
                    _vm.isCopySave
                      ? _c(
                          "span",
                          [
                            _c(
                              "el-button",
                              {
                                attrs: { no: "copySave", type: "primary" },
                                on: { click: _vm.copySave }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { no: "copyCancel", type: "primary" },
                                on: { click: _vm.copyCancel }
                              },
                              [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                            )
                          ],
                          1
                        )
                      : _c(
                          "span",
                          [
                            _c(
                              "el-upload",
                              {
                                staticStyle: { display: "inline-block" },
                                attrs: {
                                  no: "saveExcelFile2",
                                  action: _vm.url.mdm.rate.saveExcelFile2,
                                  headers: { sessionId: _vm.sessionId },
                                  data: {
                                    hqRate: _vm.hqRate,
                                    branchId: _vm.officeId,
                                    enabledChildOffice: _vm.enabledChildOffice
                                  },
                                  "show-file-list": false,
                                  accept: ".xls, .xlsx",
                                  "before-upload": _vm.beforeUpload,
                                  "on-success": _vm.uploadSuccess
                                }
                              },
                              [
                                ((_vm.hqRate &&
                                  _vm.$checkPermission(["write_SMRate"])) ||
                                  (!_vm.hqRate &&
                                    _vm.$checkPermission([
                                      "write_SMRate_updateOfficeRate"
                                    ]))) &&
                                !_vm.isParentRate
                                  ? _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          no: "excelImport",
                                          type: "primary"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("SeaExport.ExcelImport")
                                          )
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            ((_vm.hqRate &&
                              _vm.$checkPermission(["write_SMRate"])) ||
                              (!_vm.hqRate &&
                                _vm.$checkPermission([
                                  "write_SMRate_updateOfficeRate"
                                ]))) &&
                            !_vm.isParentRate
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { no: "new", type: "primary" },
                                    on: {
                                      click: _vm.popRateManagementAddFormDialog
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("common.btn.new")) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            ((_vm.hqRate &&
                              _vm.$checkPermission(["write_SMRate"])) ||
                              (!_vm.hqRate &&
                                _vm.$checkPermission([
                                  "write_SMRate_updateOfficeRate"
                                ]))) &&
                            !_vm.isParentRate
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { no: "edit", type: "primary" },
                                    on: {
                                      click: _vm.popRateManagementEditFormDialog
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("common.btn.edit")) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            ((_vm.hqRate &&
                              _vm.$checkPermission(["role_SMRate_copy"])) ||
                              (!_vm.hqRate &&
                                _vm.$checkPermission([
                                  "role_SMRate_copyOfficeRate"
                                ]))) &&
                            !_vm.isParentRate
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { no: "copyRate", type: "primary" },
                                    on: {
                                      click: _vm.popRateManagementCopyFormDialog
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "baseInfo.rateManagement.copyRate"
                                        )
                                      ) + " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            ((_vm.hqRate &&
                              _vm.$checkPermission(["role_SMRate_remove"])) ||
                              (!_vm.hqRate &&
                                _vm.$checkPermission([
                                  "role_SMRate_removeOfficeRate"
                                ]))) &&
                            !_vm.isParentRate
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { no: "delete", type: "danger" },
                                    on: { click: _vm.toDelete }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.btn.delete")))]
                                )
                              : _vm._e(),
                            _vm.isAdmin && _vm.hqRate
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "setRateCacheRange",
                                      type: "primary"
                                    },
                                    on: { click: _vm.setRateCacheRange }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "baseInfo.rateManagement.setRateCacheRange"
                                        )
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            !_vm.isParentRate
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "excelExport",
                                      type: "primary"
                                    },
                                    on: { click: _vm.exportHandler }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("SeaExport.ExcelExport"))
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.isPlatformService && _vm.hqRate,
                                    expression: "isPlatformService && hqRate"
                                  }
                                ],
                                attrs: {
                                  no: "initRatePeriod",
                                  type: "primary"
                                },
                                on: { click: _vm.initRatePeriodHandler }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_initRatePeriod")
                                  )
                                )
                              ]
                            ),
                            !_vm.hqRate &&
                            _vm.$checkPermission([
                              "role_SMRate_enabledChildOffice"
                            ]) &&
                            !_vm.isParentRate
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      no: "setEnabledChild",
                                      type: "primary"
                                    },
                                    on: { click: _vm.popSetEnabledChildDialog }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("CargoMsg.Cargo_SetEnabledChild")
                                      )
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                    !_vm.isMaintainEdit
                      ? _c(
                          "label",
                          {
                            staticStyle: {
                              color: "#BBBBBB",
                              "margin-left": "15px"
                            }
                          },
                          [_vm._v(" " + _vm._s(_vm.showRateRatio) + " ")]
                        )
                      : _vm._e(),
                    !_vm.isMaintainEdit && !_vm.hqRate
                      ? _c(
                          "label",
                          { staticStyle: { "margin-left": "100px" } },
                          [_vm._v(" " + _vm._s(_vm.showParentRateOffice) + " ")]
                        )
                      : _vm._e(),
                    !_vm.isMaintainEdit && !_vm.hqRate
                      ? _c(
                          "label",
                          { staticStyle: { "margin-left": "15px" } },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.enabledChildOfficeLabel) + " "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ])
            ]
          ),
          _c(
            "div",
            {
              staticClass: "section grid-wrapper",
              staticStyle: { "min-height": "350px" }
            },
            [
              _c("cargo-ag-grid", {
                attrs: {
                  no: "grid1",
                  "grid-params": _vm.gridParams,
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "config-module": "183345",
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "show-selected-color": false
                },
                on: {
                  "update:gridParams": function($event) {
                    _vm.gridParams = $event
                  },
                  "update:grid-params": function($event) {
                    _vm.gridParams = $event
                  },
                  gridReady: function(params) {
                    return (_vm.gridApi = params.api)
                  }
                }
              })
            ],
            1
          )
        ])
      ]),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            slot: "reference",
            no: "rateMaintain",
            "close-on-click-modal": false,
            visible: _vm.showMaintain,
            title: _vm.$t("baseInfo.rateManagement.rateMaintain"),
            "inline-message": "",
            width: "405px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showMaintain = $event
            }
          },
          slot: "reference"
        },
        [
          _c(
            "el-form",
            {
              ref: "rateManagementForm",
              attrs: {
                model: _vm.rateManagementForm,
                "label-width": "130px",
                "label-position": "right"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("baseInfo.rateManagement.currency") }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "205px" },
                    attrs: {
                      no: "currency",
                      "select-type": _vm.selectTypeNames.basic_data_Currency,
                      "callback-params": { key: "currency" },
                      "callback-method-type": "value",
                      "default-value": _vm.rateManagementForm.currency,
                      filterable: ""
                    },
                    on: { parentCallBack: _vm.selectCargoItem }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("baseInfo.rateManagement.baseCuurency")
                  }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "205px" },
                    attrs: {
                      no: "baseCurrency",
                      "select-type": _vm.selectTypeNames.basic_data_Currency,
                      "callback-params": { key: "baseCuurency" },
                      "callback-method-type": "value",
                      "default-value": _vm.rateManagementForm.baseCuurency,
                      filterable: "",
                      clearable: false
                    },
                    on: { parentCallBack: _vm.selectCargoItem }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("baseInfo.rateManagement.rate") } },
                [
                  _c("el-input", {
                    directives: [
                      {
                        name: "stopNumberMousewheel",
                        rawName: "v-stopNumberMousewheel"
                      }
                    ],
                    staticStyle: { width: "130px" },
                    attrs: {
                      value: _vm.rateManagementForm.rate,
                      no: "rate",
                      type: "number"
                    },
                    on: { input: _vm.onRateInput, change: _vm.onRateChange }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("baseInfo.rateManagement.month"),
                    prop: "month"
                  }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "130px" },
                    attrs: { no: "month", disabled: "" },
                    model: {
                      value: _vm.rateManagementForm.month,
                      callback: function($$v) {
                        _vm.$set(_vm.rateManagementForm, "month", $$v)
                      },
                      expression: "rateManagementForm.month"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_UsePeriodRate") } },
                [
                  _c(
                    "el-radio-group",
                    {
                      attrs: { no: "usePeriodRate" },
                      on: { change: _vm.rbgUsePeriodRateChangeHandler },
                      model: {
                        value: _vm.rateManagementForm.usePeriodRate,
                        callback: function($$v) {
                          _vm.$set(_vm.rateManagementForm, "usePeriodRate", $$v)
                        },
                        expression: "rateManagementForm.usePeriodRate"
                      }
                    },
                    [
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: { label: true }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Yes")))]
                      ),
                      _c(
                        "el-radio",
                        {
                          staticStyle: { "margin-right": "10px" },
                          attrs: { label: false }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_No")))]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.rateManagementForm.usePeriodRate,
                      expression: "rateManagementForm.usePeriodRate"
                    }
                  ],
                  attrs: { "label-width": "0" }
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "add", type: "primary" },
                      on: { click: _vm.addHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_add")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "del", type: "danger" },
                      on: { click: _vm.delHandler }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("cargo-ag-grid", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.rateManagementForm.usePeriodRate,
                expression: "rateManagementForm.usePeriodRate"
              }
            ],
            attrs: {
              no: "grid2",
              "show-side-bar": false,
              "auto-fit-content": false,
              "config-module": "183346",
              "grid-params": _vm.rateGridParams,
              "grid-options": _vm.rateGridOptions,
              "column-defs": _vm.rateColumnDefs,
              "row-data": _vm.rateRowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.rateGridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.rateGridParams = $event
              }
            }
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.submitRateManagement }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: { click: _vm.cancelSaveOrEdit }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            slot: "reference",
            no: "copyRateMaintain",
            "close-on-click-modal": false,
            visible: _vm.showCopyMaintain,
            title: _vm.$t("baseInfo.rateManagement.copyRateMaintain"),
            "inline-message": "",
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showCopyMaintain = $event
            }
          },
          slot: "reference"
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                "label-width": "90px",
                "label-position": "left"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  !_vm.hqRate
                    ? _c(
                        "el-form-item",
                        {
                          staticStyle: {
                            "padding-left": "20px",
                            "padding-bottom": "5px"
                          }
                        },
                        [
                          _c(
                            "el-radio-group",
                            {
                              attrs: { no: "copyHqRate" },
                              on: { change: _vm.fetchCopyRateList },
                              model: {
                                value: _vm.copyHqRate,
                                callback: function($$v) {
                                  _vm.copyHqRate = $$v
                                },
                                expression: "copyHqRate"
                              }
                            },
                            [
                              _c("el-radio", { attrs: { label: false } }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_CopyOfficeRate")
                                  )
                                )
                              ]),
                              _c("el-radio", { attrs: { label: true } }, [
                                _vm._v(
                                  _vm._s(_vm.$t("CargoMsg.Cargo_CopyHqRate"))
                                )
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Months") } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          no: "copyCurrentMonth",
                          "controls-position": "right"
                        },
                        on: { change: _vm.copyHandleChange },
                        model: {
                          value: _vm.copyCurrentMonth,
                          callback: function($$v) {
                            _vm.copyCurrentMonth = $$v
                          },
                          expression: "copyCurrentMonth"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "submitCopyRateManagement", type: "primary" },
                  on: { click: _vm.submitCopyRateManagement }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")) + " ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancelCopySaveOrEdit" },
                  on: { click: _vm.cancelCopySaveOrEdit }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      ),
      _c("rate-cache-range-dialog", {
        attrs: { visible: _vm.maintainRateCacheRangeControl },
        on: {
          "update:visible": function($event) {
            _vm.maintainRateCacheRangeControl = $event
          }
        }
      }),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "dialog",
          attrs: {
            slot: "reference",
            no: "setEnabledChildDialog",
            "close-on-click-modal": false,
            visible: _vm.showSetEnabledChildDialog,
            title: _vm.$t("CargoMsg.Cargo_SetEnabledChildDialog"),
            "inline-message": "",
            width: "400px"
          },
          on: {
            "update:visible": function($event) {
              _vm.showSetEnabledChildDialog = $event
            }
          },
          slot: "reference"
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                inline: true,
                "label-width": "80px",
                "label-position": "left"
              }
            },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    { staticStyle: { "padding-left": "20px" } },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.setEnabledChildValue,
                            callback: function($$v) {
                              _vm.setEnabledChildValue = $$v
                            },
                            expression: "setEnabledChildValue"
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_SetEnabledChildCheckbox")
                            )
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "submitSetEnabledChild", type: "primary" },
                  on: { click: _vm.submitSetEnabledChild }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancelSetEnabledChild" },
                  on: { click: _vm.cancelSetEnabledChild }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }